<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  error: { type: String, default: null },
  validationRules: { type: Object, default: () => {} },
});

const emit = defineEmits([ 'update:modelValue' ]);

const petsAllowed = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
</script>

<template>
  <div class="content-form__field form-field">
    <label class="form-field__label field-label">
      <span>{{ trans('addresses.details.form.field.pets_allowed.label') }}</span>
    </label>
    <div class="form-field__input field-input field-input--radio">
      <label>
        <input
          v-model="petsAllowed"
          class="input-radio"
          type="radio"
          :value="true"
        >
        <span>{{ trans('global.yes') }}</span>
      </label>
      <label>
        <input
          v-model="petsAllowed"
          class="input-radio"
          type="radio"
          :value="false"
        >
        <span>{{ trans('global.no') }}</span>
      </label>
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
  </div>
</template>
